// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'cadastros.cadastrosHub.eyebrow': 'Cadastros',
    'cadastros.cadastrosHub.customers': 'Clientes',
    'cadastros.cadastrosHub.hubCustomers': 'Clientes HUB',
    'cadastros.cadastrosHub.contracts': 'Contratos',
    'cadastros.cadastrosHub.users': 'Usuários',
    'cadastros.cadastrosHub.positions': 'Cargos',
    'cadastros.cadastrosHub.people': 'Pessoas',
    'cadastros.cadastrosHub.fleet': 'Frota',
    'cadastros.cadastrosHub.places': 'Locais',
    'cadastros.cadastrosHub.assets': 'Ativos',
    'cadastros.cadastrosHub.subcontracts': 'Subcontratos',
    'cadastros.cadastrosHub.fieldSheets': 'Planilhas',
    'cadastros.cadastrosHub.workFronts': 'Frentes',
    'cadastros.cadastrosHub.pairs': 'Duplas',
    'cadastros.cadastrosHub.services': 'Serviços',
    'cadastros.cadastrosHub.holidays': 'Feriados',
  },
  en: {
    'cadastros.cadastrosHub.eyebrow': 'Records',
    'cadastros.cadastrosHub.customers': 'Customers',
    'cadastros.cadastrosHub.hubCustomers': 'HUB Customers',
    'cadastros.cadastrosHub.contracts': 'Contracts',
    'cadastros.cadastrosHub.users': 'Users',
    'cadastros.cadastrosHub.positions': 'Positions',
    'cadastros.cadastrosHub.people': 'People',
    'cadastros.cadastrosHub.fleet': 'Fleet',
    'cadastros.cadastrosHub.places': 'Places',
    'cadastros.cadastrosHub.assets': 'Assets',
    'cadastros.cadastrosHub.subcontracts': 'Subcontracts',
    'cadastros.cadastrosHub.fieldSheets': 'Field sheets',
    'cadastros.cadastrosHub.workFronts': 'Work fronts',
    'cadastros.cadastrosHub.pairs': 'Pairs',
    'cadastros.cadastrosHub.services': 'Services',
    'cadastros.cadastrosHub.holidays': 'Holidays',
  },
  es: {
    'cadastros.cadastrosHub.eyebrow': 'Registros',
    'cadastros.cadastrosHub.customers': 'Clientes',
    'cadastros.cadastrosHub.hubCustomers': 'Clientes HUB',
    'cadastros.cadastrosHub.contracts': 'Contratos',
    'cadastros.cadastrosHub.users': 'Usuarios',
    'cadastros.cadastrosHub.positions': 'Cargos',
    'cadastros.cadastrosHub.people': 'Personas',
    'cadastros.cadastrosHub.fleet': 'Flota',
    'cadastros.cadastrosHub.places': 'Lugares',
    'cadastros.cadastrosHub.assets': 'Activos',
    'cadastros.cadastrosHub.subcontracts': 'Subcontratos',
    'cadastros.cadastrosHub.fieldSheets': 'Planillas',
    'cadastros.cadastrosHub.workFronts': 'Frentes',
    'cadastros.cadastrosHub.pairs': 'Parejas',
    'cadastros.cadastrosHub.services': 'Servicios',
    'cadastros.cadastrosHub.holidays': 'Feriados',
  },
}
